import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { SupportChatButton } from '../components/SupportChatButton';
import { Search, HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedItems, setExpandedItems] = useState([]);

  const faqCategories = [
    {
      category: 'Allgemein',
      questions: [
        {
          q: 'Was ist CarCortex-AI?',
          a: 'CarCortex-AI ist eine KI-gestützte Plattform für professionelle Fahrzeugdiagnose. Unser Dual-AI-System (Gemini 2.5 Pro + GPT-4o) analysiert Symptome und Fehlercodes, um präzise Diagnosen mit detaillierten Reparaturanleitungen zu erstellen. Sparen Sie bis zu 87% gegenüber traditionellen Werkstattkosten.'
        },
        {
          q: 'Für wen ist CarCortex-AI geeignet?',
          a: 'Unsere Plattform ist perfekt für: Professionelle Werkstätten (bis zu 5 zusätzliche Diagnosen pro Tag), Hobby-Schrauber (teure Werkstattbesuche vermeiden), und Fuhrparkmanager (20-30% Kostenersparnis). Sowohl Anfänger als auch Profis profitieren von unseren KI-Diagnosen.'
        },
        {
          q: 'Welche Fahrzeuge werden unterstützt?',
          a: 'Wir unterstützen alle Fahrzeuge mit OBD-II-Schnittstelle (Baujahr ab 2001 in Europa, ab 1996 in den USA). Das umfasst PKW aller Marken. Unsere KI-Fahrzeugdatenbank enthält über 1000+ verifizierte Fahrzeugmodelle mit technischen Spezifikationen.'
        },
        {
          q: 'Benötige ich technisches Vorwissen?',
          a: 'Nein! Unsere KI erklärt alles in verständlicher Sprache. Sie erhalten Schritt-für-Schritt-Anleitungen mit: exakten Positionen, benötigten Werkzeugen, Sollwerten und Sicherheitshinweisen - auch für Anfänger geeignet.'
        }
      ]
    },
    {
      category: 'Abonnement & Preise',
      questions: [
        {
          q: 'Welche Abonnement-Pläne gibt es?',
          a: 'Starter: 15.90 CHF einmalig (5 Diagnosen/Monat) - ideal zum Testen. Pro: 29.90 CHF/Monat (25 Diagnosen/Monat) - unser beliebtester Plan mit allen Features wie PDF-Berichten, Dual-AI-System, Live Web-Recherche und detaillierten Reparaturanleitungen.'
        },
        {
          q: 'Was ist im Pro-Plan enthalten?',
          a: 'Der Pro-Plan enthält: 25 Diagnosen/Monat, Dual-AI System (Gemini + GPT-4o), erweiterte Fahrzeugdatenbank, PDF-Berichte mit Zeitaufwand, Live Web-Recherche, Istwert-Beurteilung, detaillierte Prüfanweisungen, Reparatur-Anleitungen mit Werkzeugangaben, und Datei-Uploads (Foto/Video/Audio).'
        },
        {
          q: 'Kann ich mein Abonnement jederzeit kündigen?',
          a: 'Ja, Sie können jederzeit kündigen - keine Bindung! Ihr Zugang bleibt bis zum Ende der bezahlten Periode aktiv. Es gibt keine versteckten Gebühren oder Kündigungsfristen.'
        },
        {
          q: 'Was ist der Early Bird Rabatt?',
          a: 'Registrieren Sie sich vor dem Launch am 31. Januar 2026 und erhalten Sie bis zu 15% lebenslangen Rabatt! Der Rabatt gilt solange Ihr Abo aktiv ist. Zusätzlich können Sie +5% durch Empfehlungen verdienen (nur solange der Werber ein aktives Abo hat).'
        },
        {
          q: 'Wie viel spare ich gegenüber einer Werkstatt?',
          a: 'Im Durchschnitt sparen unsere Nutzer 87% pro Diagnose. Eine Werkstatt berechnet 80-150€ pro Diagnose, bei CarCortex-AI ab 1€ pro Diagnose (im Pro-Plan). Das entspricht einer Ersparnis von ca. 70-130€ pro Diagnose.'
        }
      ]
    },
    {
      category: 'KI-Diagnose',
      questions: [
        {
          q: 'Wie genau sind die KI-Diagnosen?',
          a: 'Unser Dual-AI-System erreicht 99.5% Genauigkeit. Zwei führende KI-Systeme (Gemini 2.5 Pro + GPT-4o) validieren sich gegenseitig für maximale Zuverlässigkeit. Das ist genauer als die meisten traditionellen Diagnosegeräte.'
        },
        {
          q: 'Ersetzt CarCortex-AI ein professionelles Diagnosegerät?',
          a: 'Für die meisten Anwendungsfälle ja! Unsere KI analysiert Symptome, vergleicht mit einer umfangreichen Datenbank und liefert präzise Diagnosen mit Reparaturanleitungen. Für spezielle Marken-Diagnosen oder Codierungen kann zusätzlich ein Markengerät sinnvoll sein.'
        },
        {
          q: 'Wie funktioniert die Istwert-Beurteilung?',
          a: 'Sie messen Spannung, Widerstand oder Druck - unsere KI vergleicht automatisch mit den Sollwerten für Ihr spezifisches Fahrzeug und erklärt Abweichungen verständlich. Keine Fehlinterpretationen mehr!'
        },
        {
          q: 'Wie schnell ist eine Diagnose?',
          a: 'Von Symptom zur Lösung in unter 60 Sekunden! Das ist 16x schneller als manuelle Recherche. Die KI analysiert sofort und liefert Ergebnisse mit detaillierten Anleitungen.'
        },
        {
          q: 'Was sind PDF-Berichte mit Zeitaufwand?',
          a: 'Professionelle Diagnoseberichte im PDF-Format mit geschätztem Zeitaufwand pro Arbeitsschritt. Perfekt für Kundenrechnungen, Dokumentation und als Nachweis - werkstattkonform!'
        }
      ]
    },
    {
      category: 'OBD Live-Diagnose',
      questions: [
        {
          q: 'Was ist die OBD Live-Diagnose?',
          a: 'Die revolutionäre Remote-Diagnose mit dem CarCortex OBD-Dongle. Unsere KI holt sich ALLE relevanten Daten direkt vom Fahrzeug und erstellt extrem präzise Live-Diagnosen - in Echtzeit, remote, ohne Werkstattbesuch. Der absolute GAMECHANGER!'
        },
        {
          q: 'Ist die OBD Live-Diagnose schon verfügbar?',
          a: 'Die OBD Live-Diagnose ist aktuell IN ENTWICKLUNG und wird bald verfügbar sein. Abonnenten werden als Erste benachrichtigt und erhalten exklusive Angebote. Der CarCortex OBD-Dongle wird für ca. 49.90 CHF erhältlich sein.'
        },
        {
          q: 'Wie funktioniert die Live-Diagnose?',
          a: '1) CarCortex OBD-Dongle bestellen, 2) In Fahrzeug einstecken (OBD-Buchse), 3) Desktop-Agent für Windows installieren, 4) Die KI holt sich automatisch alle Daten und erstellt die präziseste Diagnose, die Sie je gesehen haben!'
        },
        {
          q: 'Welche Plattformen werden unterstützt?',
          a: 'Der CarCortex OBD-Agent wird für Windows verfügbar sein. macOS und Linux Versionen sind in Planung. Der Dongle verbindet sich via Bluetooth automatisch.'
        }
      ]
    },
    {
      category: 'Fahrzeugdaten-Bibliothek',
      questions: [
        {
          q: 'Was ist die Fahrzeugdaten-Bibliothek?',
          a: 'Unbezahlbares Wissen, immer griffbereit! Über 1000+ verifizierte Fahrzeugdaten mit: Motoröl & Füllmengen, allen Drehmomenten (mehrstufige Anzüge inklusive), Sensor-Positionen, Sollwerten mit Toleranzen, Klimaanlagen-Spezifikationen, Fahrwerks-Einstellwerten und mehr.'
        },
        {
          q: 'Wie werden die Daten verifiziert?',
          a: 'Triple-AI Validierung! Drei verschiedene KI-Systeme durchsuchen das Web und prüfen jede Information gegenseitig auf Korrektheit. Bei über 80% Konsens wird die Information automatisch freigegeben.'
        },
        {
          q: 'Wie viel Zeit spare ich damit?',
          a: '2-3 Stunden Zeitersparnis pro Reparatur durch sofort verfügbare Daten. Kein stundenlanges Suchen mehr in Foren oder Handbüchern. Außerdem: Keine Folgeschäden durch falsche Anzugsmomente dank korrekter Sollwerte.'
        },
        {
          q: 'Was kostet eine vergleichbare Datenbank?',
          a: 'Professionelle Fahrzeugdaten-Abos kosten 500-1000€/Jahr. Bei CarCortex-AI ist die Bibliothek in den Premium-Plänen inklusive!'
        }
      ]
    },
    {
      category: 'Empfehlungsprogramm',
      questions: [
        {
          q: 'Wie funktioniert das Empfehlungsprogramm?',
          a: 'Empfehlen Sie CarCortex-AI und erhalten Sie €10 Guthaben für jedes erfolgreiche Abonnement. Unbegrenzt! 1) Registrieren und Empfehlungslink erhalten, 2) Link mit Freunden teilen (E-Mail, WhatsApp, Social Media), 3) €10 Guthaben erhalten sobald Ihr Freund ein Abo abschließt.'
        },
        {
          q: 'Gibt es ein Limit für Empfehlungen?',
          a: 'Nein! Sie können unbegrenzt viele Freunde empfehlen und €10 Guthaben pro erfolgreicher Empfehlung verdienen.'
        },
        {
          q: 'Was ist der +5% Referral-Bonus?',
          a: 'Zusätzlich zum Early Bird Rabatt erhalten Sie +5% Extra-Rabatt, wenn Sie von einem aktiven Nutzer geworben wurden. Dieser Bonus gilt nur solange der Werber ein aktives Abo hat.'
        }
      ]
    },
    {
      category: 'Datenschutz & Sicherheit',
      questions: [
        {
          q: 'Sind meine Daten sicher?',
          a: 'Absolut! Wir sind SSL-verschlüsselt und 100% DSGVO-konform. Ihre Fahrzeugdaten werden auf europäischen Servern gespeichert und niemals ohne Ihre Zustimmung geteilt oder verkauft.'
        },
        {
          q: 'Wer hat Zugriff auf meine Diagnosen?',
          a: 'Nur Sie! Ihre Diagnosen sind privat und für andere Nutzer nicht sichtbar. Unser Support-Team kann nur mit Ihrer ausdrücklichen Erlaubnis auf Daten zugreifen.'
        },
        {
          q: 'Kann ich meine Daten löschen lassen?',
          a: 'Ja! Sie können jederzeit eine vollständige Löschung Ihrer Daten beantragen (DSGVO-Recht auf Vergessenwerden) oder eine Kopie aller Ihrer Daten anfordern.'
        }
      ]
    },
    {
      category: 'Support & Hilfe',
      questions: [
        {
          q: 'Wie erreiche ich den Support?',
          a: 'E-Mail: support@carcortex-ai.com | 24/7 Support verfügbar | Geprüfte Qualität. Unser Team antwortet in der Regel innerhalb von 24 Stunden.'
        },
        {
          q: 'Gibt es Video-Tutorials?',
          a: 'Ja! Im Hilfe Center finden Sie Video-Anleitungen zu allen Features: Diagnose erstellen, PDF-Berichte generieren, Fahrzeug anlegen, und mehr.'
        },
        {
          q: 'Was passiert bei falschen Diagnosen?',
          a: 'Unser Dual-AI-System minimiert Fehldiagnosen auf ein Minimum (99.5% Genauigkeit). Sollte dennoch ein Problem auftreten, kontaktieren Sie unseren Support - wir helfen Ihnen schnell und unkompliziert.'
        }
      ]
    }
  ];

  const toggleItem = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setExpandedItems(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  };

  const isExpanded = (categoryIndex, questionIndex) => {
    return expandedItems.includes(`${categoryIndex}-${questionIndex}`);
  };

  const filteredFAQ = searchTerm
    ? faqCategories
        .map(cat => ({
          ...cat,
          questions: cat.questions.filter(
            q =>
              q.q.toLowerCase().includes(searchTerm.toLowerCase()) ||
              q.a.toLowerCase().includes(searchTerm.toLowerCase())
          )
        }))
        .filter(cat => cat.questions.length > 0)
    : faqCategories;

  return (
    <div className="min-h-screen p-8" style={{ backgroundColor: '#0B0F14' }}>
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <HelpCircle style={{ color: '#7CD4FD' }} size={32} />
            <h1 className="text-4xl font-bold" style={{ color: '#E6EDF3', fontFamily: 'Manrope' }}>
              Häufig gestellte Fragen (FAQ)
            </h1>
          </div>
          <p className="text-lg" style={{ color: '#94A3B8' }}>
            Antworten auf die wichtigsten Fragen zu CarCortex-AI
          </p>
        </div>

        {/* Search Bar */}
        <div className="mb-8">
          <div className="relative">
            <Search
              className="absolute left-3 top-1/2 transform -translate-y-1/2"
              style={{ color: '#94A3B8' }}
              size={20}
            />
            <input
              type="text"
              placeholder="Durchsuchen Sie die FAQ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 rounded-lg text-base"
              style={{
                backgroundColor: '#0F141A',
                border: '1px solid #1F2937',
                color: '#E6EDF3',
                outline: 'none'
              }}
            />
          </div>
        </div>

        {/* FAQ Content */}
        <div className="space-y-6">
          {filteredFAQ.map((category, catIdx) => (
            <Card key={catIdx} style={{ backgroundColor: '#0F141A', borderColor: '#1F2937' }}>
              <CardHeader>
                <CardTitle style={{ color: '#7CD4FD', fontSize: '1.5rem' }}>
                  {category.category}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                {category.questions.map((item, qIdx) => {
                  const expanded = isExpanded(catIdx, qIdx);
                  return (
                    <div
                      key={qIdx}
                      className="rounded-lg overflow-hidden"
                      style={{ border: '1px solid #1F2937' }}
                    >
                      <button
                        onClick={() => toggleItem(catIdx, qIdx)}
                        className="w-full px-4 py-3 flex items-center justify-between hover:bg-opacity-80 transition-all"
                        style={{ backgroundColor: '#1F2937' }}
                      >
                        <span
                          className="text-left font-medium"
                          style={{ color: '#E6EDF3', fontSize: '1rem' }}
                        >
                          {item.q}
                        </span>
                        {expanded ? (
                          <ChevronUp style={{ color: '#7CD4FD' }} size={20} />
                        ) : (
                          <ChevronDown style={{ color: '#94A3B8' }} size={20} />
                        )}
                      </button>
                      {expanded && (
                        <div
                          className="px-4 py-3"
                          style={{ backgroundColor: '#0B0F14', borderTop: '1px solid #1F2937' }}
                        >
                          <p style={{ color: '#E6EDF3', lineHeight: '1.6' }}>
                            {item.a}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* No Results */}
        {searchTerm && filteredFAQ.length === 0 && (
          <Card style={{ backgroundColor: '#0F141A', borderColor: '#1F2937' }}>
            <CardContent className="text-center py-12">
              <p style={{ color: '#94A3B8', fontSize: '1.1rem' }}>
                Keine Ergebnisse für &ldquo;{searchTerm}&rdquo; gefunden.
              </p>
              <p style={{ color: '#94A3B8', fontSize: '0.95rem', marginTop: '0.5rem' }}>
                Versuchen Sie andere Suchbegriffe oder kontaktieren Sie unseren Support.
              </p>
            </CardContent>
          </Card>
        )}

      </div>

      {/* KI-Chat Button - Floating unten rechts */}
      <SupportChatButton contextType="faq" />
    </div>
  );
};

export default FAQ;
